<template>
    <div class="animated fadeIn simulasi-page-wrapper">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else class="simulasi-container">
            <!-- Header Row -->
            <div class="simulasi-header-row">
                <div class="simulasi-header-text">
                    <h4 class="simulasi-page-title">Simulasi Gadai</h4>
                    <p class="simulasi-page-subtitle">
                        Hitung taksiran tanpa membuat pengajuan. Hasil muncul di panel kanan.
                    </p>
                </div>
            </div>

            <!-- Main 2-Column Content Grid -->
            <b-row class="simulasi-grid-row">
                <!-- Left Form Column -->
                <b-col lg="8" md="12" class="simulasi-form-col">
                    <b-form @submit.prevent="calculate">
                        <!-- DATA BARANG Card -->
                        <div class="simulasi-card mb-4">
                            <div class="simulasi-card-header">
                                <span class="simulasi-card-header-title">DATA BARANG</span>
                            </div>
                            <div class="simulasi-card-body">
                                <b-row>
                                    <b-col md="6" class="mb-3">
                                        <b-form-group label="Tipe Pinjaman" class="simulasi-form-group mb-0">
                                            <b-form-select
                                                v-model="input.tipePinjamanId"
                                                name="gadaiTipePinjaman"
                                                :options="optTipePinjaman"
                                                value-field="id"
                                                text-field="name"
                                                class="simulasi-select"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6" class="mb-3">
                                        <b-form-group label="Jenis Barang" class="simulasi-form-group mb-0">
                                            <b-form-select v-model="input.elek.jenis" name="gadaiJenisBarangElektronik" :disabled="optElekJenis.length == 0" class="simulasi-select">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                    <b-form-select-option v-for="(item, idx) in optElekJenis" :value="{ id: item.id, name: item.name }" :key="idx">
                                                        {{ item.name }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="6" class="mb-3">
                                        <b-form-group label="Merk Barang" class="simulasi-form-group mb-0">
                                            <b-form-select v-model="input.elek.merk" name="gadaiMerkBarangElektronik" :disabled="optElekMerk.length == 0" class="simulasi-select">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                    <b-form-select-option v-for="(item, idx) in optElekMerk" :value="{ id: item.id, name: item.name }" :key="idx">
                                                        {{ item.name }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6" class="mb-3">
                                        <b-form-group label="Tipe Barang" class="simulasi-form-group mb-0">
                                            <multiselect
                                                name="gadaiTipeBarangElektronik"
                                                v-model="input.elek.tipe"
                                                :disabled="optElekTipe.length == 0"
                                                :options="optElekTipe"
                                                :internal-search="true"
                                                :allow-empty="true"
                                                deselect-label=""
                                                select-label=""
                                                label="name"
                                                track-by="name"
                                                placeholder="-- Please select an option --"
                                                class="simulasi-multiselect"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="6" class="mb-0">
                                        <b-form-group label="Tahun" class="simulasi-form-group mb-0">
                                            <b-form-select
                                                v-model="input.elek.tahun"
                                                name="tahunElektronik"
                                                :options="optElekTahun"
                                                :disabled="optElekTahun.length == 0"
                                                class="simulasi-select"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6" class="mb-0">
                                        <b-form-group label="Kondisi / Grade" class="simulasi-form-group mb-0">
                                            <b-form-select 
                                                v-model="input.elek.kondisi" 
                                                name="gadaiGradeBarangClass" 
                                                :options="optElekKondisi" 
                                                :disabled="optElekKondisi.length == 0"
                                                class="simulasi-select"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>

                        <!-- SPESIFIKASI BARANG Card -->
                        <div class="simulasi-card mb-4">
                            <div class="simulasi-card-header">
                                <span class="simulasi-card-header-title">SPESIFIKASI BARANG</span>
                            </div>
                            <div class="simulasi-card-body">
                                <!-- Spesifikasi Barang (Jenis) -->
                                <div class="spec-group-section mb-4">
                                    <h6 class="spec-section-title">Spesifikasi Barang (Jenis)</h6>
                                    <b-row>
                                        <!-- Penambahan -->
                                        <b-col md="6" class="mb-3 mb-md-0">
                                            <div class="spec-box spec-box-plus">
                                                <div class="spec-box-header text-success">
                                                    <i class="fa fa-plus spec-box-icon"></i> PENAMBAHAN
                                                </div>
                                                <div v-if="optElekSpekJenis.penambahan.length == 0" class="spec-empty-text">
                                                    Tidak ada spesifikasi penambahan dari jenis barang yang dipilih.
                                                </div>
                                                <div v-else class="spec-checkbox-list">
                                                    <label 
                                                        v-for="item in optElekSpekJenis.penambahan" 
                                                        :key="item.id" 
                                                        class="custom-spec-checkbox"
                                                    >
                                                        <input 
                                                            type="checkbox" 
                                                            :value="item.id" 
                                                            v-model="input.elek.spesifikasiJenis"
                                                        />
                                                        <span class="checkbox-indicator">
                                                            <i class="fa fa-check check-icon"></i>
                                                        </span>
                                                        <span class="checkbox-label-text">{{ item.name }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>
                                        <!-- Pengurangan -->
                                        <b-col md="6">
                                            <div class="spec-box spec-box-minus">
                                                <div class="spec-box-header text-danger">
                                                    <i class="fa fa-minus spec-box-icon"></i> PENGURANGAN
                                                </div>
                                                <div v-if="optElekSpekJenis.pengurangan.length == 0" class="spec-empty-text">
                                                    Tidak ada spesifikasi pengurangan dari jenis barang yang dipilih.
                                                </div>
                                                <div v-else class="spec-checkbox-list">
                                                    <label 
                                                        v-for="item in optElekSpekJenis.pengurangan" 
                                                        :key="item.id" 
                                                        class="custom-spec-checkbox"
                                                    >
                                                        <input 
                                                            type="checkbox" 
                                                            :value="item.id" 
                                                            v-model="input.elek.spesifikasiJenis"
                                                        />
                                                        <span class="checkbox-indicator">
                                                            <i class="fa fa-check check-icon"></i>
                                                        </span>
                                                        <span class="checkbox-label-text">{{ item.name }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>

                                <!-- Spesifikasi Barang (Merk) -->
                                <div class="spec-group-section">
                                    <h6 class="spec-section-title">Spesifikasi Barang (Merk)</h6>
                                    <b-row>
                                        <!-- Penambahan -->
                                        <b-col md="6" class="mb-3 mb-md-0">
                                            <div class="spec-box spec-box-plus">
                                                <div class="spec-box-header text-success">
                                                    <i class="fa fa-plus spec-box-icon"></i> PENAMBAHAN
                                                </div>
                                                <div v-if="optElekSpekMerk.penambahan.length == 0" class="spec-empty-text">
                                                    Tidak ada spesifikasi penambahan dari merk barang yang dipilih.
                                                </div>
                                                <div v-else class="spec-checkbox-list">
                                                    <label 
                                                        v-for="item in optElekSpekMerk.penambahan" 
                                                        :key="item.id" 
                                                        class="custom-spec-checkbox"
                                                    >
                                                        <input 
                                                            type="checkbox" 
                                                            :value="item.id" 
                                                            v-model="input.elek.spesifikasiMerk"
                                                        />
                                                        <span class="checkbox-indicator">
                                                            <i class="fa fa-check check-icon"></i>
                                                        </span>
                                                        <span class="checkbox-label-text">{{ item.name }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>
                                        <!-- Pengurangan -->
                                        <b-col md="6">
                                            <div class="spec-box spec-box-minus">
                                                <div class="spec-box-header text-danger">
                                                    <i class="fa fa-minus spec-box-icon"></i> PENGURANGAN
                                                </div>
                                                <div v-if="optElekSpekMerk.pengurangan.length == 0" class="spec-empty-text">
                                                    Tidak ada spesifikasi pengurangan dari merk barang yang dipilih.
                                                </div>
                                                <div v-else class="spec-checkbox-list">
                                                    <label 
                                                        v-for="item in optElekSpekMerk.pengurangan" 
                                                        :key="item.id" 
                                                        class="custom-spec-checkbox"
                                                    >
                                                        <input 
                                                            type="checkbox" 
                                                            :value="item.id" 
                                                            v-model="input.elek.spesifikasiMerk"
                                                        />
                                                        <span class="checkbox-indicator">
                                                            <i class="fa fa-check check-icon"></i>
                                                        </span>
                                                        <span class="checkbox-label-text">{{ item.name }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </div>

                        <!-- Form Actions -->
                        <div class="simulasi-form-actions">
                            <button type="button" class="btn btn-simulasi-reset" @click="resetForm">
                                Reset
                            </button>
                            <button type="submit" class="btn btn-simulasi-hitung" :disabled="isSubmitting" name="simulasiHitungElektronikBtn">
                                <i class="fa fa-calculator mr-2" v-if="!isSubmitting"></i>
                                <b-spinner small type="grow" class="mr-2" v-if="isSubmitting"></b-spinner>
                                {{ isSubmitting ? "Menghitung..." : "Hitung" }}
                            </button>
                        </div>
                    </b-form>
                </b-col>

                <!-- Right Sidebar Panel: TAKSIRAN GADAI -->
                <b-col lg="4" md="12" class="simulasi-sidebar-col">
                    <div class="taksiran-panel-container">
                        <div class="taksiran-card">
                            <div class="taksiran-header">
                                <span class="taksiran-header-title">TAKSIRAN GADAI</span>
                                <span class="taksiran-status-dot"></span>
                            </div>
                            <div class="taksiran-body">
                                <!-- Empty State -->
                                <div v-if="!hasCalculated" class="taksiran-empty-state">
                                    <div class="empty-icon-box">
                                        <span class="empty-equal-sign">=</span>
                                    </div>
                                    <h6 class="empty-title">Belum dihitung</h6>
                                    <p class="empty-desc">
                                        Lengkapi data barang lalu tekan Hitung. Rincian taksiran tampil di sini.
                                    </p>
                                </div>

                                <!-- Calculated State -->
                                <div v-else class="taksiran-result-state">
                                    <div class="result-barang-name mb-3">
                                        <i class="fa fa-tag mr-1 text-primary"></i> {{ barangName }}
                                    </div>

                                    <!-- Highlight Box: Nilai Taksiran -->
                                    <div class="result-highlight-card mb-3">
                                        <span class="result-highlight-label">Nilai Taksiran Gadai</span>
                                        <h4 class="result-highlight-val">
                                            Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaTaksiran) }}
                                        </h4>
                                        <div class="result-range-row">
                                            <div class="range-item">
                                                <span class="range-lbl">Min Pinjaman</span>
                                                <strong class="range-val">Rp. {{ $helper.addThousandSeparator(dataPinjam.minimumPinjaman) }}</strong>
                                            </div>
                                            <div class="range-divider"></div>
                                            <div class="range-item">
                                                <span class="range-lbl">Maks Pinjaman</span>
                                                <strong class="range-val">Rp. {{ $helper.addThousandSeparator(dataPinjam.maksimumPinjaman) }}</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Detail List Breakdown -->
                                    <div class="result-detail-list mb-3">
                                        <div class="result-detail-item">
                                            <span class="detail-name">Harga Barang</span>
                                            <span class="detail-val">Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaBarang) }}</span>
                                        </div>
                                        <div class="result-detail-item" v-if="dataPinjam.perhitunganKondisi && dataPinjam.perhitunganKondisi.name">
                                            <span class="detail-name">Kondisi - Grade {{ dataPinjam.perhitunganKondisi.name }}</span>
                                            <span class="detail-val" :class="dataPinjam.perhitunganKondisi.nominal < 0 ? 'text-danger' : ''">
                                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganKondisi.nominal) }}
                                            </span>
                                        </div>
                                        <div class="result-detail-item" v-if="dataPinjam.perhitunganAdjustmentSkemaDidepan != null">
                                            <span class="detail-name">Adjustment Jasa Didepan</span>
                                            <span class="detail-val" :class="dataPinjam.perhitunganAdjustmentSkemaDidepan < 0 ? 'text-danger' : ''">
                                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganAdjustmentSkemaDidepan) }}
                                            </span>
                                        </div>
                                        <div 
                                            class="result-detail-item" 
                                            v-for="item in dataPinjam.perhitunganSpek" 
                                            :key="item.name"
                                        >
                                            <span class="detail-name">{{ item.name }}</span>
                                            <span class="detail-val" :class="item.nominal < 0 ? 'text-danger' : ''">
                                                Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                                            </span>
                                        </div>
                                    </div>

                                    <!-- Estimasi Biaya pada Maks Pinjaman (master parameter wilayah x tipe pinjaman x jenis barang) -->
                                    <div class="result-detail-list mb-3" v-if="dataPinjam.biayaAdmin != null">
                                        <div class="result-detail-item">
                                            <span class="detail-name">Estimasi Biaya Admin</span>
                                            <span class="detail-val text-danger">Rp. {{ $helper.addThousandSeparator(dataPinjam.biayaAdmin) }}</span>
                                        </div>
                                        <div class="result-detail-item" v-if="dataPinjam.biayaJasaPertama != null">
                                            <span class="detail-name">Estimasi Jasa Bulan Pertama</span>
                                            <span class="detail-val text-danger">Rp. {{ $helper.addThousandSeparator(dataPinjam.biayaJasaPertama) }}</span>
                                        </div>
                                        <div class="result-detail-item">
                                            <span class="detail-name">Estimasi Diterima (Maks Pinjaman)</span>
                                            <span class="detail-val">Rp. {{ $helper.addThousandSeparator(dataPinjam.jumlahDiterima) }}</span>
                                        </div>
                                    </div>

                                    <!-- Warning Alert -->
                                    <b-alert 
                                        variant="warning" 
                                        class="p-2 mb-3 small" 
                                        :show="dataPinjam.maksimumPinjaman < dataPinjam.batasBawahPinjaman"
                                    >
                                        <strong>Perhatian!</strong> Pinjaman maksimal tidak mencapai ketentuan batas bawah pinjaman {{ $companyName }}.
                                    </b-alert>

                                    <!-- Action Buttons -->
                                    <div class="result-actions">
                                        <button 
                                            type="button" 
                                            class="btn btn-result-print w-100" 
                                            @click="tampilanCetak" 
                                            :disabled="isSubmitting"
                                        >
                                            <i class="fa fa-print mr-2"></i>
                                            {{ isSubmitting ? "Proses Cetak..." : "Cetak Taksiran" }}
                                        </button>
                                        <button 
                                            type="button" 
                                            class="btn btn-result-modal w-100 mt-2" 
                                            @click="$bvModal.show('modal-data-pinjaman')"
                                        >
                                            <i class="fa fa-expand mr-2"></i> Lihat Rincian Lengkap
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Panel Disclaimer Note -->
                        <p class="taksiran-disclaimer">
                            Simulasi tidak membuat pengajuan dan tidak tersimpan pada riwayat cabang.
                        </p>
                    </div>
                </b-col>
            </b-row>
        </div>

        <!-- Detail Modal (for comprehensive view & backwards compatibility) -->
        <b-modal id="modal-data-pinjaman" title="Taksiran Gadai" size="lg" ok-only ok-title="Tutup" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title mb-2">RINCIAN BARANG</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Barang</b-col>
                    <b-col><strong>{{ barangName }}</strong></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Harga Barang</b-col>
                    <b-col><strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaBarang) }}</strong></b-col>
                </b-row>
                <b-row class="mb-2" v-if="dataPinjam.perhitunganKondisi">
                    <b-col cols="5" class="detail-data-label">Kondisi - Grade {{ dataPinjam.perhitunganKondisi.name }}</b-col>
                    <b-col :class="dataPinjam.perhitunganKondisi.nominal < 0 ? 'text-danger' : ''">
                        <strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganKondisi.nominal) }}</strong>
                    </b-col>
                </b-row>
                <b-row v-if="dataPinjam.perhitunganAdjustmentSkemaDidepan != null">
                    <b-col cols="5" class="detail-data-label">Adjustment Jasa Didepan</b-col>
                    <b-col :class="dataPinjam.perhitunganAdjustmentSkemaDidepan < 0 ? 'text-danger' : ''">
                        <strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganAdjustmentSkemaDidepan) }}</strong>
                    </b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4" v-if="dataPinjam.perhitunganSpek && dataPinjam.perhitunganSpek.length > 0">
                <h6 class="form-title mb-2">RINCIAN SPESIFIKASI</h6>
                <b-row v-for="item in dataPinjam.perhitunganSpek" :key="item.name" class="mb-2">
                    <b-col cols="5" class="detail-data-label">{{ item.name }}</b-col>
                    <b-col :class="item.nominal < 0 ? 'text-danger' : ''">
                        <strong>Rp. {{ $helper.addThousandSeparator(item.nominal) }}</strong>
                    </b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title mb-2">PERHITUNGAN PINJAMAN</h6>
                <b-row class="mb-2" v-if="dataPinjam.hargaMaksimalKondisi != null">
                    <b-col cols="5" class="detail-data-label">Harga Maksimal Kondisi</b-col>
                    <b-col><strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaMaksimalKondisi) }}</strong></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Pinjaman Maksimal</b-col>
                    <b-col>
                        <strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.maksimumPinjaman) }}</strong>
                        <span class="smallText text-muted">(Setelah Pembulatan)</span>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Pinjaman Minimal</b-col>
                    <b-col><strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.minimumPinjaman) }}</strong></b-col>
                </b-row>
                <b-row>
                    <b-col cols="5" class="detail-data-label">Harga Taksiran</b-col>
                    <b-col><strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaTaksiran) }}</strong></b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4" v-if="dataPinjam.biayaAdmin != null">
                <h6 class="form-title mb-2">ESTIMASI BIAYA (PADA PINJAMAN MAKSIMAL)</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Biaya Admin</b-col>
                    <b-col class="text-danger"><strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.biayaAdmin) }}</strong></b-col>
                </b-row>
                <b-row class="mb-2" v-if="dataPinjam.biayaJasaPertama != null">
                    <b-col cols="5" class="detail-data-label">Jasa Bulan Pertama</b-col>
                    <b-col class="text-danger"><strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.biayaJasaPertama) }}</strong></b-col>
                </b-row>
                <b-row>
                    <b-col cols="5" class="detail-data-label">Jumlah Diterima</b-col>
                    <b-col><strong>Rp. {{ $helper.addThousandSeparator(dataPinjam.jumlahDiterima) }}</strong></b-col>
                </b-row>
            </div>
            <b-alert variant="warning" class="mt-0" :show="dataPinjam.maksimumPinjaman < dataPinjam.batasBawahPinjaman">
                <strong>Perhatian!</strong><br />
                Gadai ini dapat saja ditolak karena pinjaman maksimal anda tidak mencapai ketentuan batas bawah pinjaman {{ $companyName }}.
            </b-alert>
            <b-button variant="pgiBtn" @click="tampilanCetak" :disabled="isSubmitting">
                <i class="fa fa-print mr-2"></i>
                {{ isSubmitting ? "Proses Cetak..." : "Cetak" }}
            </b-button>
        </b-modal>

        <!-- Print Modal -->
        <b-modal title="Print Taksiran Gadai" ok-only no-close-on-esc no-close-on-backdrop size="xl" id="modal-print">
            <b-row class="mb-2">
                <b-col class="detail-data-label">Taksiran Gadai</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><iframe width="100%" height="300" :src="urlTaksiran" frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'simulasi-gadai',
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            cabangId: '',

            hasCalculated: false,

            input: {
                tipePinjamanId: null,
                elek: {
                    jenis: null,
                    jenisName: null,
                    merk: null,
                    merkName: null,
                    tipe: null,
                    tipeName: null,
                    tahun: null,
                    kondisi: null,
                    spesifikasiJenis: [],
                    spesifikasiMerk: []
                }
            },

            dataPinjam: {
                hargaBarang: 0,
                maksimumPinjaman: 0,
                minimumPinjaman: 0,
                hargaTaksiran: 0,
                batasBawahPinjaman: 0,
                perhitunganAdjustmentSkemaDidepan: null,
                perhitunganKondisi: {},
                perhitunganSpek: [],
                biayaAdmin: null,
                biayaJasaPertama: null,
                jumlahDiterima: 0
            },

            optTipePinjaman: [],
            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],
            optElekTahun: [],
            optElekKondisi: [],
            optElekSpekJenis: {
                penambahan: [],
                pengurangan: []
            },
            optElekSpekMerk: {
                penambahan: [],
                pengurangan: []
            },

            barangName: null,
            urlTaksiran: null
        }
    },
    methods: {
        //----------------- Inisialisasi -----------------
        init() {
            this.initStatus = 0

            this.$axios.get("tipe-pinjaman/selection").then(response => {
                this.optTipePinjaman = response.data
                this.initStatus = 1
                this.cabangId = this.$helper.getCabangId()
                if (this.optTipePinjaman.length > 0 && this.input.tipePinjamanId == null) {
                    this.input.tipePinjamanId = this.optTipePinjaman[0].id
                }
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        resetForm() {
            this.input.elek = {
                jenis: null,
                jenisName: null,
                merk: null,
                merkName: null,
                tipe: null,
                tipeName: null,
                tahun: null,
                kondisi: null,
                spesifikasiJenis: [],
                spesifikasiMerk: []
            }
            this.optElekMerk = []
            this.optElekTipe = []
            this.optElekTahun = []
            this.optElekKondisi = []
            this.optElekSpekJenis = { penambahan: [], pengurangan: [] }
            this.optElekSpekMerk = { penambahan: [], pengurangan: [] }
            this.dataPinjam = {
                perhitunganKondisi: {},
                perhitunganSpek: []
            }
            this.barangName = null
            this.hasCalculated = false
        },

        calculate() {
            // Validation
            if (this.input.tipePinjamanId == null) {
                this.$helper.toastErr(this, "Mohon memilih tipe pinjaman!")
                return
            }
            if (!this.input.elek.jenis) {
                this.$helper.toastErr(this, "Mohon memilih jenis barang!")
                return
            }
            if (!this.input.elek.merk) {
                this.$helper.toastErr(this, "Mohon memilih merk barang!")
                return
            }
            if (!this.input.elek.tipe) {
                this.$helper.toastErr(this, "Mohon memilih tipe barang!")
                return
            }
            if (this.optElekTahun.length != 0 && this.input.elek.tahun == null) {
                this.$helper.toastErr(this, "Mohon memilih tahun barang!")
                return
            }
            if (this.input.elek.kondisi == null) {
                this.$helper.toastErr(this, "Terdapat data tidak lengkap, mohon periksa kembali!")
                return
            }

            let payload = new FormData()
            payload.append("jenisPinjamanId", this.input.tipePinjamanId)
            payload.append("jenisId", this.input.elek.jenis.id)
            payload.append("merkId", this.input.elek.merk.id)
            payload.append("tipeId", this.input.elek.tipe.id)
            payload.append("kondisiId", this.input.elek.kondisi)
            payload.append("cabangId", this.cabangId)

            if (this.input.elek.tahun != null) {
                payload.append("tahunId", this.input.elek.tahun)
            }

            for (let spek of this.input.elek.spesifikasiJenis) {
                payload.append("spesifikasiId", spek)
            }

            for (let spek of this.input.elek.spesifikasiMerk) {
                payload.append("spesifikasiId", spek)
            }

            this.isSubmitting = true
            this.$axios.post("gadai-crud/simulasi", payload).then(response => {
                if (response.data.noFaktur == 'REFRESH_KONDISI') {
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                    this.input.elek.kondisi = null
                    this.$axios.get(`barang-tipe/kondisi/${this.input.elek.tipe.id}`).then(response => {
                        this.optElekKondisi = response.data.map(item => {
                            return { value: item.id, text: item.name }
                        })
                    })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                } else {
                    this.dataPinjam = response.data
                    this.barangName = this.input.elek.jenis.name + " - " + this.input.elek.merk.name + " - " + this.input.elek.tipe.name
                    this.hasCalculated = true
                }
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        tampilanCetak() {
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("cabangId", this.cabangId)

            let sendToServer = {}
            sendToServer.barang = {}
            sendToServer.barang.barang = this.barangName
            sendToServer.barang.hargaBarang = this.$helper.addThousandSeparator(this.dataPinjam.hargaBarang)
            sendToServer.barang.kondisi = "Kondisi - Grade " + (this.dataPinjam.perhitunganKondisi ? this.dataPinjam.perhitunganKondisi.name : '')
            sendToServer.barang.potonganKondisi = this.$helper.addThousandSeparator(this.dataPinjam.perhitunganKondisi ? this.dataPinjam.perhitunganKondisi.nominal : 0)
            sendToServer.spesifikasi = []
            if (this.dataPinjam.perhitunganSpek && Array.isArray(this.dataPinjam.perhitunganSpek)) {
                this.dataPinjam.perhitunganSpek.forEach(element => {
                    let temp = {}
                    temp.name = element.name
                    temp.nominal = this.$helper.addThousandSeparator(element.nominal)
                    sendToServer.spesifikasi.push(temp)
                })
            }
            sendToServer.pinjamanMaksimum = this.$helper.addThousandSeparator(this.dataPinjam.maksimumPinjaman)
            sendToServer.pinjamanMinimum = this.$helper.addThousandSeparator(this.dataPinjam.minimumPinjaman)
            sendToServer.hargaTaksiran = this.$helper.addThousandSeparator(this.dataPinjam.hargaTaksiran)

            if (this.dataPinjam.perhitunganAdjustmentSkemaDidepan != null) {
                sendToServer.adjustmentJasaDidepan = this.$helper.addThousandSeparator(this.dataPinjam.perhitunganAdjustmentSkemaDidepan)
            }

            payload.append("input", JSON.stringify(sendToServer))

            this.$axios.post("gadai/simulasi/cetak", payload).then(response => {
                this.urlTaksiran = this.$baseFilePath + response.data.name
                this.$bvModal.show("modal-print")
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        }
    },
    watch: {
        'input.tipePinjamanId': function(newVal) {
            this.optElekJenis = []
            this.input.elek.jenis = null
            this.hasCalculated = false

            if (newVal == null) { return }

            this.$axios.get(`barang-jenis/jenis-pinjaman/${newVal}`).then(response => {
                this.optElekJenis = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
        },

        'input.elek.jenis': function(newVal) {
            this.optElekMerk = []
            this.input.elek.merk = null
            this.optElekSpekJenis = { penambahan: [], pengurangan: [] }
            this.input.elek.spesifikasiJenis = []

            if (newVal == null) { return }

            this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                this.optElekMerk = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })

            this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
                this.optElekSpekJenis = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
        },

        'input.elek.merk': function(newVal) {
            this.optElekTipe = []
            this.input.elek.tipe = null
            this.optElekSpekMerk = { penambahan: [], pengurangan: [] }
            this.input.elek.spesifikasiMerk = []

            if (newVal == null) { return }

            this.$axios.get(`barang-tipe/merk/${newVal.id}`).then(response => {
                this.optElekTipe = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })

            this.$axios.get(`barang-merk/spesifikasi?merkId=${newVal.id}`).then(response => {
                this.optElekSpekMerk = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
        },

        'input.elek.tipe': function(newVal) {
            this.optElekTahun = []
            this.input.elek.tahun = null
            this.optElekKondisi = []
            this.input.elek.kondisi = null

            if (newVal == null) { return }

            this.$axios.get(`barang-tipe/tahun/${newVal.id}`).then(response => {
                this.optElekTahun = response.data.map(item => {
                    return { value: item.id, text: item.name }
                })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })

            this.$axios.get(`barang-tipe/kondisi/${newVal.id}`).then(response => {
                this.optElekKondisi = response.data.map(item => {
                    return { value: item.id, text: item.name }
                })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
        }
    },
    created() {
        this.init()
    }
}
</script>

<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-dark: #072D28;
$deep-pine-hover: #0A5247;
$sage-strip-bg: #E3EDE6;
$body-canvas: #F4F6F4;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #6E827C;
$line-border: #E2E7E3;
$accent-amber: #E58A2B;
$green-spec-bg: #F5FAF6;
$green-spec-border: #DCE8E1;
$green-spec-text: #1E6B4E;
$red-spec-bg: #FCF6F5;
$red-spec-border: #F3E3E1;
$red-spec-text: #C04C3D;

.simulasi-page-wrapper {
    padding-bottom: 30px;
}

.simulasi-container {
    max-width: 100%;
}

// 1. Header & Segmented Tab Switcher (Regular Rounded)
.simulasi-header-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 16px;
}

.simulasi-page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    margin-bottom: 4px;
    letter-spacing: -0.01em;
}

.simulasi-page-subtitle {
    font-size: 13px;
    color: $ink-muted;
    margin-bottom: 0;
}

// 2. Simulasi Cards
.simulasi-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.simulasi-card-header {
    background-color: $sage-strip-bg;
    padding: 10px 20px;
    border-bottom: 1px solid rgba(2, 56, 49, 0.06);
}

.simulasi-card-header-title {
    font-size: 11px;
    font-weight: 700;
    color: $deep-pine;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    display: inline-block;
}

.simulasi-card-body {
    padding: 20px 24px;
}

// 3. Form Controls Styling
.simulasi-form-group {
    ::v-deep label {
        font-size: 12.5px;
        font-weight: 600;
        color: $ink-body;
        margin-bottom: 6px;
        display: block;
    }
}

.simulasi-select {
    height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #D8E2DC !important;
    background-color: #FFFFFF !important;
    font-size: 13px !important;
    color: $ink-body !important;
    padding: 6px 12px !important;
    width: 100% !important;
    max-width: 100% !important;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
        border-color: $deep-pine !important;
        outline: none !important;
        box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.12) !important;
    }

    &:disabled {
        background-color: #F7FAF8 !important;
        color: #8C9F98 !important;
        cursor: not-allowed;
    }
}

.simulasi-multiselect {
    max-width: 100% !important;
    width: 100% !important;

    ::v-deep .multiselect__tags {
        min-height: 40px;
        border-radius: 8px;
        border: 1px solid #D8E2DC;
        padding-top: 8px;
        font-size: 13px;
    }

    ::v-deep .multiselect__placeholder {
        margin-bottom: 0;
        padding-top: 0;
        font-size: 13px;
        color: #6c757d;
    }

    ::v-deep .multiselect__single {
        font-size: 13px;
        color: $ink-body;
        margin-bottom: 0;
        padding-top: 0;
    }

    ::v-deep .multiselect__select {
        height: 38px;
    }
}

// 5. Spesifikasi Boxes (Penambahan & Pengurangan)
.spec-section-title {
    font-size: 13px;
    font-weight: 600;
    color: $ink-body;
    margin-bottom: 10px;
}

.spec-box {
    border-radius: 10px;
    padding: 12px 16px;
    min-height: 85px;

    &.spec-box-plus {
        background-color: $green-spec-bg;
        border: 1px solid $green-spec-border;

        .spec-box-header {
            color: $green-spec-text;
        }
    }

    &.spec-box-minus {
        background-color: $red-spec-bg;
        border: 1px solid $red-spec-border;

        .spec-box-header {
            color: $red-spec-text;
        }
    }
}

.spec-box-header {
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .spec-box-icon {
        font-size: 9px;
        margin-right: 6px;
    }
}

.spec-empty-text {
    font-size: 12px;
    color: #8A9E96;
    font-style: italic;
}

.spec-checkbox-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.custom-spec-checkbox {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 0;
    user-select: none;

    input[type="checkbox"] {
        display: none;
    }

    .checkbox-indicator {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: 1.5px solid #BAC9C2;
        background-color: #FFFFFF;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        transition: all 0.15s ease;

        .check-icon {
            font-size: 10px;
            color: #FFFFFF;
            opacity: 0;
            transform: scale(0.6);
            transition: all 0.15s ease;
        }
    }

    .checkbox-label-text {
        font-size: 12.5px;
        color: $ink-body;
        font-weight: 500;
    }

    input[type="checkbox"]:checked + .checkbox-indicator {
        background-color: $deep-pine;
        border-color: $deep-pine;

        .check-icon {
            opacity: 1;
            transform: scale(1);
        }
    }

    &:hover .checkbox-indicator {
        border-color: $deep-pine;
    }
}

// 6. Action Buttons
.simulasi-form-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
    margin-bottom: 24px;
}

.btn-simulasi-reset {
    background-color: #FFFFFF;
    border: 1px solid #D5DFDA;
    color: $ink-body;
    font-size: 13px;
    font-weight: 600;
    padding: 7px 22px;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover {
        background-color: #F4F7F5;
        border-color: #BAC9C2;
        color: $ink-heading;
    }
}

.btn-simulasi-hitung {
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 600;
    padding: 7px 24px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(2, 56, 49, 0.2);

    &:hover:not(:disabled) {
        background-color: $deep-pine-hover;
        border-color: $deep-pine-hover;
        color: #FFFFFF;
    }

    &:disabled {
        opacity: 0.75;
        cursor: not-allowed;
    }
}

// 7. Right Column: TAKSIRAN GADAI Panel
.taksiran-panel-container {
    position: sticky;
    top: 20px;
}

.taksiran-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.taksiran-header {
    background-color: $deep-pine;
    padding: 12px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.taksiran-header-title {
    color: #FFFFFF;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
}

.taksiran-status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: $accent-amber;
    display: inline-block;
}

.taksiran-body {
    padding: 24px 20px;
    min-height: 240px;
}

// Empty State
.taksiran-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 10px;

    .empty-icon-box {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        background-color: #EEF4F0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;

        .empty-equal-sign {
            font-size: 20px;
            font-weight: 700;
            color: #6E827C;
            line-height: 1;
        }
    }

    .empty-title {
        font-size: 14px;
        font-weight: 700;
        color: $ink-heading;
        margin-bottom: 6px;
    }

    .empty-desc {
        font-size: 12px;
        color: $ink-muted;
        max-width: 220px;
        line-height: 1.45;
        margin-bottom: 0;
    }
}

// Calculated State
.taksiran-result-state {
    .result-barang-name {
        font-size: 13px;
        font-weight: 700;
        color: $deep-pine;
        border-bottom: 1px solid #EDF2EF;
        padding-bottom: 8px;
    }

    .result-highlight-card {
        background-color: #F4F8F5;
        border: 1px solid #DFEBE3;
        border-radius: 10px;
        padding: 14px 16px;
        text-align: center;

        .result-highlight-label {
            font-size: 11px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            color: #556B63;
            display: block;
            margin-bottom: 4px;
        }

        .result-highlight-val {
            font-size: 20px;
            font-weight: 800;
            color: $deep-pine;
            margin-bottom: 10px;
        }

        .result-range-row {
            display: flex;
            justify-content: space-around;
            align-items: center;
            border-top: 1px dashed #D3E2D8;
            padding-top: 8px;
            margin-top: 4px;

            .range-item {
                display: flex;
                flex-direction: column;

                .range-lbl {
                    font-size: 10px;
                    color: $ink-muted;
                }

                .range-val {
                    font-size: 11.5px;
                    color: $ink-body;
                }
            }

            .range-divider {
                width: 1px;
                height: 22px;
                background-color: #D3E2D8;
            }
        }
    }

    .result-detail-list {
        background-color: #FAFDFB;
        border: 1px solid #E6EFEA;
        border-radius: 8px;
        padding: 8px 12px;

        .result-detail-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            padding: 5px 0;
            border-bottom: 1px solid #F0F5F2;

            &:last-child {
                border-bottom: none;
            }

            .detail-name {
                color: $ink-muted;
            }

            .detail-val {
                font-weight: 600;
                color: $ink-body;
            }
        }
    }

    .btn-result-print {
        background-color: $deep-pine;
        color: #FFFFFF;
        border: none;
        border-radius: 8px;
        font-size: 12.5px;
        font-weight: 600;
        padding: 8px 16px;
        transition: all 0.2s;

        &:hover:not(:disabled) {
            background-color: $deep-pine-hover;
        }
    }

    .btn-result-modal {
        background-color: #FFFFFF;
        border: 1px solid #D5DFDA;
        color: $ink-body;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 500;
        padding: 6px 14px;
        transition: all 0.2s;

        &:hover {
            background-color: #F4F7F5;
            border-color: #BAC9C2;
        }
    }
}

.taksiran-disclaimer {
    font-size: 11.5px;
    color: #7E918B;
    line-height: 1.4;
    margin-top: 12px;
    padding: 0 4px;
}
</style>
